/* eslint-disable react-hooks/rules-of-hooks */
import React from 'react';
import 'moment/locale/pt';
import { Box, Button, CircularProgress, FormControl, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import InputMask from "react-input-mask";
import moment from 'moment';
import { toast } from 'react-toastify';
import api from '../../../../services/api';
import { PostFetch } from '../../../../services/apiBase';

export default function detailsClientModal({ client, onClose, loadingClientAmount, clientAmount, clientClassifications, updateClientList }) {

  const [personneClassificationId, setPersonneClassificationId] = React.useState(client.personne_classification_id)

  const updateClassification = async (clientId, classificationId) => {
    try {

      const response = await PostFetch(`/subscription/personne-classification`, {
        id: classificationId,
        personne_id: clientId
      })

      if (response.status === 200) {
        toast.success('Classificação atualizada com sucesso!')
        setPersonneClassificationId(classificationId)
        updateClientList()
        onClose()
      }
    } catch (error) {
      toast.error('Erro ao atualizar classificação!')
      console.log(error)
    }
  }


  return (
    <Box sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      boxShadow: 24,
      borderRadius: 2,
      backgroundColor: grey[300]
    }}>
      <Box sx={{
        padding: '16px',
        borderRadius: '8px 8px 0 0',
        backgroundColor: '#fff'
      }}>
        <Typography variant="h6" component="h2">
          Detalhes
        </Typography>
      </Box>

      <Box sx={{
        marginTop: '16px',
        marginBottom: '16px',
        marginRight: '32px',
        width: 800,
        minWidth: 1200,
        maxHeight: '75vh',
        height: '80%',
        width: '100%',
        overflow: "hidden",
        overflowY: "scroll",
        backgroundColor: '#fff',
        borderRadius: 1,
        display: 'flex',
        flexDirection: 'column',
        padding: 2,
        gap: 2
      }}>

        <Typography variant="h6" component="h2">
          informações do cliente
        </Typography>

        <Box sx={{ display: 'flex', gap: 2 }}>
          <FormControl fullWidth>
            {client.documents.length > 0 ? 
              <InputMask
                mask={client.documents[0].document_number.length > 11 ? "99.999.999/9999-99" : "999.999.999-99"}
                maskChar=" "
                disabled
                value={client.documents[0].document_number}
              >
                {() =>
                  <TextField
                    disabled={true}
                    label="CPF/CNPJ"
                  />
                }
              </InputMask>
              :
              <TextField
                disabled
                label="CPF/CNPJ"
                value='Não informado'
              />
            }
          </FormControl>

          <FormControl fullWidth>
            <TextField
              disabled
              value={client.name}
              label="Nome completo"
            />
          </FormControl>
        </Box>

        <Box sx={{display: 'flex', gap: 2}}>
          <FormControl fullWidth>
            <TextField
              disabled
              value={client.gender ?? 'Não informado'}
              label="Sexo"
            />
          </FormControl>

          <FormControl fullWidth>
            <TextField
              disabled
              value={client.birth_date ? moment.utc(client.birth_date).format('L') : 'Não informado'}
              label="Aniversário"
            />
          </FormControl>

          <FormControl fullWidth>
            <TextField
              disabled
              value={client.marital ?? 'Não informado'}
              label="Estado civil"
            />
          </FormControl>
        </Box>

        <Box sx={{ display: 'flex', gap: 2 }}>
          <FormControl fullWidth>
            <TextField
              disabled
              value={client.nationality ?? 'Não informado'}
              label="Nacionalidade"
            />
          </FormControl>
          
          <FormControl fullWidth>
            <TextField
              disabled
              value={client.professions?.name ?? 'Não informado'}
              label="Profissão"
            />
          </FormControl>

          <FormControl fullWidth>
            <TextField
              disabled
              value={client.investor_profiles?.name ?? 'Não informado'}
              label="Perfil"
            />
          </FormControl>
        </Box>

        <Box sx={{ display: 'flex', gap: 2 }}>
          <FormControl fullWidth sx={{ gap: 2 }}>
            {client.phones.length > 0 ? client.phones.map(phone => (
              <TextField
                disabled
                value={`${phone.country} ${phone.area} ${phone.phone_number}` ?? 'Não informado'}
                label="Telefone"
              />

            )) : 
              <TextField
                disabled
                value={'Não informado'}
                label="Telefone"
              />
            }
          </FormControl>

          <FormControl fullWidth sx={{ gap: 2 }}>
            {client.emails.length > 0 ? client.emails.map(email => (
              <TextField
                disabled
                value={email.email ?? 'Não informado'}
                label="E-mail"
              />

            )) : 
              <TextField
                disabled
                value={'Não informado'}
                label="E-mail"
              />
            }
          </FormControl>
        </Box>
        
        <Typography variant="h6" component="h2">
          Endereço
        </Typography>

        <Box sx={{ display: 'flex', gap: 2 }}>
          <FormControl fullWidth>
            <TextField
              disabled
              value={client?.addresses[0]?.name ?? 'Não informado'}
              label="Rua"
            />
          </FormControl>

          <FormControl fullWidth>
            <TextField
              disabled
              value={client?.addresses[0]?.number ?? 'Não informado'}
              label="Número"
            />
          </FormControl>
        </Box>

        <Box sx={{ display: 'flex', gap: 2 }}>
          <FormControl fullWidth>
            <TextField
              disabled
              value={client?.addresses[0]?.postcode ?? 'Não informado'}
              label="CEP"
            />
          </FormControl>
          
          <FormControl fullWidth>
            <TextField
              disabled
              value={client?.addresses[0]?.city.name_city ?? 'Não informado'}
              label="Cidade"
            />
          </FormControl>

          <FormControl fullWidth>
            <TextField
              disabled
              value={client?.addresses[0]?.city.name_uf ?? 'Não informado'}
              label="Estado"
            />
          </FormControl>
        </Box>

        {client.documents.find(doc => doc.type !== 'CPF') &&
          <Typography variant="h6" component="h2">
            Documentos
          </Typography>
        }

        {client.documents.length > 0 ? client.documents.map(document => (
          document.type !== "CPF" &&
          <>
            <Box sx={{display: 'flex', gap: 2}}>
              <FormControl fullWidth>
                <TextField
                  disabled
                  value={document.type ?? 'Não informado'}
                  label="Tipo de documento"
                />
              </FormControl>

              <FormControl fullWidth>
                <TextField
                  disabled
                  value={document.document_number ?? 'Não informado'}
                  label="Número do documento"
                />
              </FormControl>
            </Box>

            <Box sx={{display: 'flex', gap: 2}}>
              <FormControl fullWidth>
                <TextField
                  disabled
                  value={document.agency_issuing ?? 'Não informado'}
                  label="Órgão"
                />
              </FormControl>

              <FormControl fullWidth>
                <TextField
                  disabled
                  value={document.document_number ?? 'Não informado'}
                  label="UF do doc"
                />
              </FormControl>
            </Box>
          </>
        )) : null}

        <Typography variant="h6" component="h2">
          Dados bancários
        </Typography>

        <Box sx={{ display: 'flex', gap: 2 }}>
          <FormControl fullWidth>
            <TextField
              disabled
              value={client?.bank_accounts[0]?.account_number ?? 'Não informado'}
              label="Conta bancária"
            />
          </FormControl>

          <FormControl fullWidth>
            {loadingClientAmount ?
              <CircularProgress />
              :
              clientAmount === 0 ?
                <TextField
                  disabled
                  value={Intl.NumberFormat('pt-br', {style: 'currency', currency: 'BRL'}).format(clientAmount)}
                  label="Saldo"
                />
                :
                <TextField
                  disabled
                  value={clientAmount ? Intl.NumberFormat('pt-br', {style: 'currency', currency: 'BRL'}).format(clientAmount) : 'Não informado'}
                  label="Saldo"
                />
            }
          </FormControl>
        </Box>


        <Typography variant="h6" component="h2">
          Classificação
        </Typography>
        <Box sx={{ display: 'flex', gap: 2 }}>
          <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">Selecione</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            label="Selecione o tipo"
            value={personneClassificationId}
            onChange={e => {
              updateClassification(client.id, e.target.value);
            }}
          >
            {clientClassifications?.map(classification => (
              <MenuItem key={classification.id} value={classification.id}>{classification.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
        </Box>


      </Box>

      <Box sx={{
        display: 'flex',
        width: '100%',
        justifyContent: 'flex-end',
        gap: 1,
        padding: 2,
        borderRadius: '0 0 8px 8px',
        backgroundColor: '#fff'
      }}>
        <Button variant="contained" color='error' onClick={onClose}>
          <Typography color={'#fff'}>
            Fechar
          </Typography>
        </Button>
      </Box>
    </Box>
  )
}
